// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"81":"e8a5dd4fa2510dda","778":"5fc04b7b3e87f418"}[chunkId] + ".js";
};